module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw PushDown-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block5"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC#title-num3a"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "center-rw"
  }, [_c('img', {
    staticClass: "chorn",
    attrs: {
      "alt": "image",
      "src": "images/Art_chorn.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p251"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("E")]), _vm._v("nding the day at her parents’ house for Sunday dinner was not an option. Babette Holden could sniff out a scandal like a bloodhound with wounded prey. Her mother would take one look at Charlotte, smell the scent of impending divorce, and before Charlotte could explain the situation a traditional Southern wedding fit for a former Miss Peach would be planned and executed. Because the only thing worse than Babette Holden’s only daughter eloping with the town bad boy was divorce.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("Admitting her marriage had been over the first time had nearly killed her. The fact that she had to face it again was starting to give her hives. She didn’t need her parents influencing her decision.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("Nope, Charlotte was going to go home, open a bottle of champagne, and finish it in one chug while wearing her sexiest nightgown. Then she would fall into a drunken sleep, convince herself that her life wasn’t rapidly spiraling out of control, and if that didn’t work, break into the ice cream she’d been hiding in her freezer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("That had been her plan.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("Until she realized she was stranded in town, with no car, in a pair of adorable yet impractical heels, with only two options. Ask her ex-husband, who had apparently messed up filing for the “ex” part of the title, for a ride home, or see just how far stubborn pride could carry her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("When the blister on her right pinkie toe grew to the size of the Mississippi, Charlotte went for option three. Which was how she ended up seated at her parents’ formal dining table, across from a potential investor, while on a blind date with a bald man who kept dropping his napkin—on her adorable heels—only to retrieve it slowly, while her mother smiled on.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("“Disposable inserts,” Babette mused, as though Lionel had discovered the solution to global warming. “Just fascinating. Isn’t that fascinating, Charlotte?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("And because Charlotte was a classy Southern woman, she smiled generously before hiding an eye roll behind her wineglass as she took a generous swallow. Her mother would think that growing grass was fascinating if the man was loaded, connected, and interested. And based on the way Lionel’s fingers grazed Charlotte’s arch every time he dropped his napkin, he was interested.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“The bottom line,” Charlotte heard Tipton Neil say to her father, “is you are just too small for the board’s comfort. We recently had to pull funding from a midsize project out west less than a year into the partnership because the local support dried up after the clinic received our endowment. Since then, the board is hesitant to invest in smaller companies.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("“You have my word that won’t happen here,” Reginald assured him. “Sugar Medical Center has been owned and operated by the Holden family for over ninety years. And for ninety years we have served this community with dignity and pride.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_c('i', [_vm._v("Huh,")]), _vm._v(" no wonder Charlotte had a perfection complex.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("“And the town realizes that,” Babette said in a regal tone, which, combined with her entitled pearls and heirloom attitude, made her appear the lady of the manor speaking of her serfs. Not the modern-day image of teamwork Charlotte wanted to portray.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("“We’re not just a town clinic, we are "), _c('i', [_vm._v("the")]), _vm._v(" town’s clinic, and we work hard to be a positive part of the community,” Charlotte explained. “When we announced the need for a new pediatric ward and the Grow Clinic, the town came together to raise the million dollars needed for the expansion.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("“It was lovely,” Babette said. “They hosted bake sales and potlucks, even a fish-a-thon.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("“A fish-a-thon?” Mr. Neil did not sound impressed. In fact, he sounded as if her mother’s attempt to help had only helped reconfirm his original concerns—Sugar was a small town with a small clinic. Too small a fish for Mercy Alliance to do anything with but let go.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("That’s what got to Charlotte most of all. She was tired of being tossed back, wanted the chance to prove Sugar was worth the investment, worthy of Mercy’s time and commitment.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("“Here in Sugar we believe that it takes a village to raise a hospital, and it takes a whole lot of love to save a child,” Charlotte explained. “We may be short on census numbers, but we have enough support and heart to make a difference. To these kids and the families in this county, the Grow Clinic is the difference between life and really living. We’ve built the clinic, the doors are nearly ready to open, and now we need Mercy’s help to make sure that all the patients have access to the treatment they need. Regardless of insurance.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("Tipton put down his knife and studied her—really studied her—and Charlotte knew that she was getting through. It wasn’t about numbers, it was about people and saving lives. That was why Mercy Alliance was founded, and that was why Charlotte did what she did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("“Which is why the town decided to dedicate this year’s Founder’s Day Fair in support of Sugar Medical,” Babette lied, and Charlotte choked on her own spit.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("“Mom,” she whispered, but Babette wouldn’t be deterred.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("“There will be local booths selling wares, the annual Sheep Scurry and Trials, and a televised parade hosted by our homegrown golf royalty, Brett McGraw.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("“It’s only a local access show,” Charlotte clarified, while giving her mother a gentle nudge under the table to cool it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("Unfortunately, Babette was raised to believe that the most important skill a woman could possess, other than the ability to glisten instead of perspire, was hosting a dinner party that would be talked about. So, if it made the company more exciting, then it was not a sin to embellish the facts. “I heard that they are holding it in the medical center’s parking lot.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("“Actually,” Charlotte said, trying to hide the panic creeping around her neck, because everyone knew that Babette would tell Mr. Neil that Sugar Medical had discovered the cure for cancer if it meant her dinner would be the talk of someone else’s table for weeks to come, “the Founder’s Day Fair has traditionally been held on Maple Street since the first general store and post office opened its front doors back in 1846.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("Tipton looked perplexed. “And this year they are holding it at the medical center?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("“Well, I don’t see why not,” her mother said, raising her glass as though it were a wonderful idea. As though it had been decided. As though they could just change the location of a 169-year-old tradition.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("“And Charlotte is heading up the entire event,” her mother said, then whispered to Lionel, “Knows how to keep her house in order, just ask anyone.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("Yes, because after achieving a doctorate and dedicating ten years of her life toward the advancement of medicine, the most impressive thing about her is her super-fantastic party planning skills.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("“That is a lot to take on with your practice and the Grow Clinic,” Mr. Neil said, now sounding concerned.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("And since the last thing she needed Mr. Neil thinking was that the head of his potential investment would be too busy polishing her pearls to head up the clinic, she said, “The Grow Clinic is my focus.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p281"
    }
  }, [_vm._v("Her mother sighed heavily, then whispered to Lionel, “Which is why she’s single.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("“I am just helping out with the event,” Charlotte clarified over her mother’s comment. “It is really the Sugar Peaches who run the show.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("“The Sugar Peaches is an exclusive local woman’s organization dedicated to upholding our county’s rich tradition of giving back to our community,” her mother added, as though anyone cared. “And Charlotte is the current regent.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("“Dad,” she whispered as her mother outlined the complete history of the social organization in the same way one would explain the three branches of government. “We can’t move the fair.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("“You’re a Holden,” he whispered back. “You can do anything you set your mind to. You want this Grow Clinic to include pro bono treatment? Then get that endowment secured or we go back to my plan.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("Which meant no insurance, no treatment.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("“You want me to lie?” Her father might not be known for a warm and fuzzy bedside manner, but he wasn’t a liar.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("“I want you to finish what you started,” he said. “Plus it’s not like they’re going to come to the parade.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_vm._v("“What was that, dear?” her mother asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("Her father cleared his throat and smiled. “Charlotte was explaining how most of the proceeds from the fair will go toward the Grow Clinic and its patients. It should cover the remaining funds needed to purchase the pediatric physical therapy machines and install the wireless network for the research center.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_vm._v("And because nearly every one of Charlotte’s decisions were influenced by two factors, making her father proud or horrifying her mother, she gave her brightest smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("Neither confirming nor denying her father’s big fat lie.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p293"
    }
  }, [_vm._v("“That is the kind of commitment we are looking for, Reggie,” Tipton said, clapping her father on the back. “Mercy Alliance wants to pursue organizations that exhibit the same dedication to medical care as our company.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("“Ninety years,” her dad repeated, and just like that the conversation was over in his mind. He pulled out the proposal Charlotte had sent him. The one she’d spent the entire weekend reworking, only to have him reject it on the grounds that it “needed work.” "), _c('i', [_vm._v("Now")]), _vm._v(" it seemed to be fine, since he handed it to Mr. Neil. “Take a look at this, and let my office know if there is anything else you need. I’d like to wrap up the paperwork before the end of the month, so we can announce the endowment at the Founder’s Day Fair.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_vm._v("“You’re a hard man to say no to, Reggie.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_c('i', [_vm._v("Preaching to the choir, ")]), _vm._v("Charlotte thought, because by “my office” he meant Charlotte, since no one knew as much, or cared as much, about the Grow Clinic as she did. Sure, he hadn’t implied that Charlotte was his secretary, as he’d done in the past, but he’d passed off her hard work as his. She could have said something. Should have. But she didn’t—an annoying character flaw she was determined to work on.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_vm._v("But then Mr. Neil smiled and said, “Let me take this to the board and see what I can do,” and Charlotte decided she’d work on it tomorrow because Lionel dropped his napkin again, and Babette looked delighted at the outcome of her dinner.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration4"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p299"
    }
  }, [_vm._v("When it came to family and favors, Jace knew that doing the right thing would likely come back and bite him in the ass. And this favor was going to leave marks. Hell, just standing there in the garage at Kiss My Glass and looking at the burned-out hull of the car his family wanted him to rebuild was already pissing off his chest. Even worse, it was bringing some pretty intense feeling that he’d thought he’d buried years ago.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("“Christ,” he mumbled, running a hand over his face and heading for the door—and space that didn’t reek of the past.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("He stepped out into the crisp autumn night and watched a couple of maple leaves blow down the empty cobblestone sidewalk and into the street. The cool air filled his lungs, and he did his best to get a handle on all the emotions threatening to take him under. When that didn’t work, he decided to ignore them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("There had been a time in Jace’s life when he couldn’t imagine leaving the wide-open plains of Sugar, but that was before. Before that summer. Before the fire. And before he cost his family everything.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("But no matter how far he ran, how many shitholes he was sent to, how many battles he fought, he couldn’t seem to outrun the slug-size hole growing in his chest. Until he’d met Charlotte, and in typical Jace fashion, he’d destroyed that, too.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("Now he was back in the only place that had ever felt like home, surprisingly still married to the only woman he’d ever loved, and he was going to walk away. Again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_c('i', [_vm._v("And wasn’t that fan-fucking-tastic")]), _vm._v(", he thought, crossing Maple Street and bypassing his truck—not to mention the dozen texts from his brothers telling him to get his butt to dinner. And since sitting at the family table surrounded by his brothers and their ball-and-chain bliss required a few drinks, he headed for the swinging doors of the local honky-tonk.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("He was happy for what his brothers had built. Happy that they’d found that same insane connection and undeniable love that their parents shared. He really was. But being surrounded by everything he wanted, everything he’d once had, knowing he was never going to get it back made his chest hurt.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("And tonight he’d let his own selfish needs take precedence, because his family didn’t ask him for much, which was why telling them no was going to suck. This was one favor he couldn’t come through on. And even if he could, he wouldn’t be around long enough to rebuild that car.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("Hell, all the time in the world wouldn’t be enough for him to rebuild that car, and he only had two days.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("Jace took a deep breath and entered the Saddle Rack. Stepping inside the bar was like wading neck-deep in his past, literally. The dark wood dance floor, neon beer signs, and mile-long bar top was exactly the same as when he’d left. Even worse, there wasn’t a face he didn’t recognize—and they all seemed to recognize him back.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("Tipping his ball cap at half the town, Jace headed straight for the bar, passing the other half, it seemed, and stopped.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_c('i', [_vm._v("Well, shit. ")]), _vm._v("His brother Brett was seated in their old spot at the far end of the counter. An empty stool on one side of him, two frosty longnecks on the other. And he was waiting. The smug, brother-knows-best look said he was waiting for Jace—that he knew he’d bail on the family dinner and come here instead.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("Locking eyes, Brett lifted his beer and saluted—challenging Jace to avoid him now.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("He considered just that, except Sunday night football had taken over the Saddle Rack, so there wasn’t another spare seat in the joint. Otherwise Jace would have taken his beer and found somewhere that didn’t stink of “projects” and disappointment. Jace took the stool next to Brett, making sure to jab him a few times while getting settled. “Shouldn’t you be at home eating dinner?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("“I could ask you the same,” Brett said, sliding a beer in front of Jace.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("“Was going to grab a drink then head on over,” he lied, and Brett knew it but didn’t call him on it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("“Cal bet you were just running late.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p317"
    }
  }, [_vm._v("“Cal’s always been my favorite brother.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("“That’s because he didn’t know half the shit you pulled growing up. Which is why I put twenty on you hiding out here instead of facing Grandma.” Brett clinked his bottle against Jace’s and lifted it in a toast. “Here’s to you being a total pussy.” Then took a long pull.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("Unable to argue that, Jace joined him, the cold liquid doing not a thing to help his breathing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("“Now that that’s settled, why don’t you go thank your wife for making that fancy dinner?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("“You say that like I didn’t already try.” Brett eyed him—hard—then toed the brown paper bag at his feet. A little puff of heavenly smelling steam escaped. “Mom’s meatloaf, garlic mashed potatoes, Hattie’s green beans, and a whole pecan pie.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("“You brought me dinner?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p323"
    }
  }, [_vm._v("“Hell, no, I brought you this.” He gave Jace a swift punch to the shoulder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p324"
    }
  }, [_vm._v("“Ow!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p325"
    }
  }, [_vm._v("“That is from Joie,” Brett said, going back to his beer. “When you didn’t show, she packed up two helpings and a whole pie to go. Said I couldn’t have dessert until she knew you’d been fed. The mommy flip was switched and she can’t do "), _c('i', [_vm._v("anything ")]), _vm._v("until everyone is taken care of now. So take the damn food. Eat it, and fast. Then call Joie and tell her how delicious it was, so she’ll give me my dessert before one of us falls asleep.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p326"
    }
  }, [_vm._v("Jace leaned over and peeked inside the bag. It looked good and smelled even better. Like garlic and grease and his childhood—and home. God, it smelled like home. “Hey, there’s a piece of pie missing.” He eyed Brett. “Like a half-the-pie piece.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p327"
    }
  }, [_vm._v("“You’re lucky I left you anything. Do you realize my daughter is fed and bathed and fast asleep?” Brett looked at Jace with the eyes of a man who hadn’t seen more than four hours of sleep a night in the past nine months. “In her crib, man. Not my bed. Her crib. And instead of me getting my ‘taken care of time’ I am here. With you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p328"
    }
  }, [_vm._v("Brett dropped his head on the bar top with a thunk, and Jace actually felt for the guy. Little Lily Anne McGraw, with her blonde curls and Daddy-do eyes, came out swinging. It was amazing how a kid smaller than a gas can had the ability to wrap a PGA superstar around her pudgy little finger with one coo.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p329"
    }
  }, [_vm._v("“Yeah, well, I spent most of the day trying to figure out how the hell you got ahold of a ’61 Stingray just like Dad’s,” Jace said, the last few words getting caught in his throat, making it hard to breathe. "), _c('i', [_vm._v("Jesus")]), _vm._v(", he hadn’t felt this kind of slow suffocation since he was a teenager. “By this evening I realized it "), _c('i', [_vm._v("was")]), _vm._v(" Dad’s.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p330"
    }
  }, [_vm._v("Which seemed impossible. Jace had come to terms a long time ago that the car he’d spent two summers rebuilding with his dad was gone. His dad had sent it off to be repainted, cherry red like Hattie had wanted, then the fire had happened, and when none of the local shops had a record of the car, he’d considered it lost.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p331"
    }
  }, [_vm._v("“Are you pissed because I didn’t tell you or because it was Dad’s?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p332"
    }
  }, [_vm._v("Jace wisely didn’t respond, taking another pull of his beer instead. Only three people in the world had the ability to read Jace like a book. One was gone, the other wanted him gone, which left his brother Brett. “Where did you find it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p333"
    }
  }, [_vm._v("“When the crew was demoing what was left of the old farmhouse, they found it under the collapsed boathouse,” he said, referring to the small garage that had been near the lake on their parents’ property.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p334"
    }
  }, [_vm._v("Last year, Brett had retired from the professional golf circuit to raise a family in Sugar—and he’d chosen to build his home on their parents’ property. Kudos to Brett for making himself and his family a home, but it’s not what Jace would have done with the property. Not that anyone asked Jace how he felt about it—just like they hadn’t asked him how he felt about rebuilding his dad’s old car.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p335"
    }
  }, [_vm._v("“What was it doing in there?” The shed was near the water, and that was the last place to keep that kind of car.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p336"
    }
  }, [_vm._v("“I don’t know, but Hattie’s already been telling folks that she’s going to ride in it with her new granddaughter for the Founder’s Day Parade. Excited about there being three generations of McGraws,” Brett said, making what Jace was about to say that much worse.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p337"
    }
  }, [_vm._v("Hattie cruising the Founder’s Day Parade in the Stingray was a family tradition. It started the year she’d married Ray McGraw and continued with her sitting beside her son, years later her new daughter-in-law, then again every year each of the boys had been born. It was a rite of passage in the McGraw family, her way of making a public declaration that this was her family. These were her people.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p338"
    }
  }, [_vm._v("Then, the summer before Jace turned fifteen, they lost his parents and the car to a fire, and with it the tradition.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p339"
    }
  }, [_vm._v("“I told Dale I’d be back in Atlanta by Tuesday,” Jace said. “There is no way I can get that fixed before I leave.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p340"
    }
  }, [_vm._v("“Use some of that vacation time you’ve been accumulating,” Brett said, as though it were that simple. Jace was secretly relieved that it wasn’t. And didn’t that make him a prick. “If Dale knew it was for Hattie, he would give you the time off.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p341"
    }
  }, [_vm._v("And here was the second conversation he’d been trying to postpone. “Dale needs cash to expand the Beverly Hills location, so he’s selling the Atlanta shop.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p342"
    }
  }, [_vm._v("Brett’s eyes went wide. “He’s selling? Wow, he’s been talking about it for years, but I never thought he’d actually do it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p343"
    }
  }, [_vm._v("“He’s selling the Atlanta shop to me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p344"
    }
  }, [_vm._v("There was a long, weighted silence as Brett took in exactly what that meant. Jace knew the minute Brett put it together—Jace buying Dale’s shop meant he was finally putting down roots. A safe two hundred miles from his family.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p345"
    }
  }, [_vm._v("Two hundred miles away from watching his nieces grow up. From his brothers. From the past.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p346"
    }
  }, [_vm._v("“I’m happy for you, bro. I wish it was closer to us, but I get it,” Brett said, and Jace felt his chest relax a little, because if anyone could understand Jace’s need for space, it was Brett. Before he’d met Joie, Brett had done his fair share of running, too. Sure, now he was happily living the domesticated dream in Sugar—he deserved it. But even if Jace had thought he deserved that life, it wasn’t his dream. Not anymore.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p347"
    }
  }, [_vm._v("“Does Hattie know?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p348"
    }
  }, [_vm._v("Jace shook his head. “I haven’t told anyone yet.” "), _c('i', [_vm._v("Except Charlotte")]), _vm._v(". “There is some paperwork I have to get finished up before we can finalize the deal, but Dale is determined to close by the end of October. Which is why I have to head back to Atlanta in a few days.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p349"
    }
  }, [_vm._v("Even if he couldn’t get Charlotte to agree to come, maybe he could get her to sign some kind of official statement saying she wanted the annulment to go forward. Or maybe he’d just throw her in his truck. Either way, he wasn’t missing his meeting with the recorder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p350"
    }
  }, [_vm._v("“Congratulations, I know this is what you’ve wanted.” When Jace didn’t say anything, Brett added, “This is what you want, right?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p351"
    }
  }, [_vm._v("“Owning a garage like Atlanta Motorsports?” Jace snorted. “It’s been my dream since I was eleven and Dad took me to that car show in Atlanta and I got to sit in that ’65 Le Mans Ferrari.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p352"
    }
  }, [_vm._v("Brett’s smile stayed in place, but there was something about it that felt forced. “What are you going to do about Dad’s car?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p353"
    }
  }, [_vm._v("Guilt rolled through him, pinching his skull. “I know a guy who does clean work and owes me a favor.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p354"
    }
  }, [_vm._v("Brett let out a low whistle and shook his head. “Make sure I’m there when you tell Hattie that "), _c('i', [_vm._v("you ")]), _vm._v("aren’t doing the work. I’d like to see what that looks like, because ever since she saw that article on you in "), _c('i', [_vm._v("Car and Driver")]), _vm._v(" she’s been telling anyone who’ll listen how you’re going to use all those fancy skills to get the Stingray looking like the day she came home.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p355"
    }
  }, [_vm._v("Last month, "), _c('i', [_vm._v("Car and Driver ")]), _vm._v("magazine had done a spread on the top ten up-and-coming exotic car specialists in the country, and Jace had damn near topped the list. It was what had finally convinced Dale to sell. Jace’s reputation as an engine specialist had put him in high demand, keeping Dale’s shop booked months in advance. When that article was published, offers flooded in and Dale knew that if he didn’t sell the shop to Jace then Jace would eventually move on and open his own. He was practically running Dale’s as it was.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p356"
    }
  }, [_vm._v("“I said I’d look at the car,” Jace defended, his stomach feeling squirrelly. “I did, and there is no way I can get that fixed before I leave.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p357"
    }
  }, [_vm._v("“Did I mention she cut out the article and showed it to her knitting group?” Brett said, and, yup, he was going to be sick. Or his heart was going to explode right out of his chest.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p358"
    }
  }, [_vm._v("Jace came back to Sugar with a clear goal: get in, get a signature, and get back to Atlanta to open his shop. No detours, no pit stops, just a straight shot toward something good. But to let down the woman who had sacrificed so much to make sure he had a loving home after his parents passed? Who could do that?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p359"
    }
  }, [_vm._v("He sure as hell couldn’t, not when he knew what parading through town in that car meant to her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p360"
    }
  }, [_vm._v("“Then she hung it on the fridge. It’s next to Payton’s report card,” Brett added, and Jace wanted to punch him.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aab38c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s006-PushDown-002.vue
// module id = 81
// module chunks = 0